import React from "react";
import { CDN } from "../../redux/helpers/urlConfig";
import { useDispatch, useSelector } from "react-redux";
import { handleFileUpload } from "../../utils";
import { LoadingModal } from "./loading";
import axiosInstance from "../../redux/helpers/axios";
import { getAdminByToken } from "../../redux/actions";

/**
 * @author
 * @function ProfileModal
 **/

export const ProfileModal = ({ open, onClose }) => {
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);

  const [loading, setLoading] = React.useState(false);

  const handleClose = (e) => {
    onClose();
  };

  const handleImgUpload = async (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      return;
    }
    try {
      const file = e.target.files[0];
      setLoading(true);
      const { key, path } = await handleFileUpload(file, "admin");

      await axiosInstance.post("/admin/services/update-avatar", {
        key,
        path,
      });

      dispatch(getAdminByToken());

      setLoading(false);
    } catch (error) {
      console.error("Error uploading profile image:", error);
      setLoading(false);
    }
  };

  const countryName = new Intl.DisplayNames(["en"], {
    type: "region",
  });

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[9999]">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/30 backdrop-blur-[2px] rounded-2xl" />

      {/* Modal */}
      <div className="absolute inset-0 flex items-center justify-center px-4">
        <div className="w-full max-w-md rounded-2xl bg-white shadow-xl border border-slate-100 p-5">
          <div className="flex flex-col gap-3">
            {loading && <LoadingModal text="Updating avatar..." />}
            <div>
              <h1 className="text-md font-semibold text-slate-800">
                Edit Profile
              </h1>
            </div>

            <div className="flex flex-col items-center gap-3">
              <div className="relative h-36 w-36">
                {auth?.admin?.avatar ? (
                  <img
                    src={`${CDN}${auth?.admin?.avatar?.path}`}
                    className="h-36 w-36 rounded-full"
                    alt="User Avatar"
                  />
                ) : (
                  <img
                    src="https://placehold.co/400x400"
                    className="h-36 w-36 rounded-full"
                    alt="User Avatar"
                  />
                )}

                <label
                  htmlFor="profileImage"
                  className="absolute bottom-1 right-1 bg-black bg-opacity-70 p-2 rounded-full cursor-pointer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 7h4l2-3h6l2 3h4v12H3V7z"
                    />
                    <circle cx="12" cy="13" r="3" />
                  </svg>
                  <input
                    id="profileImage"
                    type="file"
                    accept="image/*"
                    onChange={handleImgUpload}
                    className="hidden"
                  />
                </label>
              </div>

              <div>
                <h2 className="text-lg font-semibold text-slate-900">
                  {auth?.admin?.name || "Admin Name"}
                </h2>
                <p className="text-sm text-slate-500">
                  {auth?.admin?.email || "admin@alistore.com.bd"}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="grid gap-2">
                <label className="text-sm text-slate-600">Country</label>
                <input
                  value={countryName.of(auth?.admin?.country) || ""}
                  disabled
                  className="rounded-xl border border-slate-200 px-3 py-2 outline-none focus:ring-2 focus:ring-slate-200"
                />
              </div>

              <div className="grid gap-2">
                <label className="text-sm text-slate-600">Phone</label>
                <input
                  value={auth?.admin?.phone || ""}
                  disabled
                  className="rounded-xl border border-slate-200 px-3 py-2 outline-none focus:ring-2 focus:ring-slate-200"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="grid gap-2">
                <label className="text-sm text-slate-600">Gender</label>
                <input
                  value={auth?.admin?.gender || ""}
                  disabled
                  className="rounded-xl border border-slate-200 px-3 py-2 outline-none focus:ring-2 focus:ring-slate-200"
                />
              </div>

              <div className="grid gap-2">
                <label className="text-sm text-slate-600">Date of Birth</label>
                <input
                  value={new Date(auth?.admin?.birthday).toDateString() || ""}
                  disabled
                  className="rounded-xl border border-slate-200 px-3 py-2 outline-none focus:ring-2 focus:ring-slate-200"
                />
              </div>
            </div>

            <div className="mt-5">
              <button
                onClick={handleClose}
                className="w-full rounded-2xl bg-slate-100 px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-200 transition"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
